<template>
  <div class="whats-panel">
    <div class="whats-header">
      <span class="whats-header-spacer"></span>
      <span class="whats-header-title">
        <span class="whats-header-icon">
          <v-icon size="13" color="#FFFFFF">mdi-whatsapp</v-icon>
        </span>
        {{ $t('newLinkWhatsapp') }}
      </span>
      <button
        type="button"
        class="whats-close-btn"
        :disabled="loadingSave"
        @click="JSON.stringify(dataNumber) == JSON.stringify(aux) ? data.dialog = false : confimCancel.dialog = true"
      >
        <v-icon size="18">mdi-close</v-icon>
      </button>
    </div>
    <v-divider/>
    <div class="whats-body">
      <p class="whats-section-desc">{{ $t(`enterYourWhatsappNumber`) }}</p>
      <v-form v-model="form" :disabled="loadingSave">
        <v-row>
          <v-col cols="12" xs="12" sm="5">
            <v-autocomplete
              v-model="dataNumber.dialCode"
              :items="countries"
              filled
              rounded
              :label="$t('ddiDescrition')"
              color="primary"
              :item-value="(locale) => locale.dialCode"
              item-text="name"
              dense
              class="whats-text-field"
              :rules="[value => !!value || $t('required')]"
            >
              <!-- Slot para os itens da lista -->
              <template v-slot:item="data">
                <div class="d-flex align-center">
                  <country-flag :country="data.item.flagCode"  class="mr-2" />
                  <span>{{ data.item.name }}  <div class="description--text">+{{ data.item.dialCode }}</div></span>
                </div>
              </template>

              <!-- Slot para o item selecionado -->
              <template v-slot:selection="data">
                <div class="d-flex align-center">
                  <country-flag :country="data.item.flagCode" size="small" class="mr-2" />
                  <span><div class="description--text">+{{ data.item.dialCode }}</div></span>
                </div>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="7">
            <v-text-field
              v-model="dataNumber.number"
              filled
              rounded
              dense
              :label="$t('phoneNumber')"
              color="primary"
              type="tel"
              maxlength="15"
              counter="15"
              class="whats-text-field"
              :rules="[
                value => !!value || $t('required'),
                value => /^[0-9]{8,15}$/.test(value) || $t('invalidPhone')
              ]"
              >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <p class="whats-section-label">{{ $t(`whatspaMessage`) }}</p>

            <!-- Botões de formatação -->
            <div class="whats-format-toolbar">
              <button type="button" class="whats-format-btn" @click="applyFormat('bold')">
                <v-icon size="17">mdi-format-bold</v-icon>
              </button>
              <button type="button" class="whats-format-btn" @click="applyFormat('italic')">
                <v-icon size="17">mdi-format-italic</v-icon>
              </button>
              <button type="button" class="whats-format-btn" @click="applyFormat('strike')">
                <v-icon size="17">mdi-format-strikethrough-variant</v-icon>
              </button>
              <button type="button" class="whats-format-btn" @click="applyFormat('code')">
                <v-icon size="17">mdi-xml</v-icon>
              </button>
            </div>
            <!-- Caixa de texto -->
            <v-textarea
              ref="messageInput"
              v-model="dataNumber.message"
              filled
              rounded
              dense
              :label="$t('whatspaMessage')"
              color="primary"
              counter
              maxlength="1000"
              rows="3"
              no-resize
              class="whats-text-field"
              ></v-textarea>
            <div class="whats-emoji-row">
              <button type="button" class="whats-emoji-btn" @click="showEmojis = !showEmojis">
                {{ $t('addEmoji') }} <v-icon size="17" class="ml-1">mdi-emoticon-outline</v-icon>
              </button>
            </div>
            <v-fade-transition>
              <picker @select="addEmoji" v-if="showEmojis"/>
            </v-fade-transition>
            <!-- Preview da mensagem formatada -->
            <div class="whats-preview-card" v-if="formattedMessage">
              <p class="whats-preview-label">{{ $t(`whatspaMessageFormated`) }}</p>
              <div v-html="formattedMessage"></div>
            </div>
            <v-switch class="whats-switch" :label="$t('autoWhatssShortenLinks')" inset color="#0277BD" v-model="autoShortLinks"></v-switch>
            <div class="whats-info-card" v-if="autoShortLinks">
              <v-icon size="18" color="#0277BD" class="mr-2">mdi-information-outline</v-icon>
              {{ $t('whatssInfoShortenLinks') }}
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>

    <div class="whats-footer">
      <a v-if="form" :href="getWhatsappUrl()" target="_blank" class="whats-test-btn">
        {{ $t('test') }}
      </a>
      <button type="button" class="whats-save-btn" :disabled="!form || loadingSave" @click="save">
        <span class="whats-save-spinner" v-if="loadingSave"></span>
        <span v-else>{{ $t('save') }}</span>
      </button>
    </div>
    <ConfirmOperation :data="confimCancel" :confimAction="() => {data.dialog = false, dataNumber = JSON.parse(JSON.stringify(aux))}" />
  </div>
</template>
<script>
import { Picker } from 'emoji-mart-vue'
import ConfirmOperation from './ConfirmOperation.vue';
const countryCodes = require('country-codes-list')
import {apiV1OnlineAddresses} from "../../../service/resources/api-v1-online-addresses";
  export default {
    name: 'UrlShortenerWhattsApp',
    props: ['address', 'data', 'onSave', 'url'],
    components: {ConfirmOperation, Picker},
    data: () => ({
      form: false,
      autoShortLinks: true,
      aux: {
        dialCode: null,
        number: null,
        message: "",
      },
      showEmojis: false,
      dataNumber: {
        dialCode: null,
        number: null,
        message: "",
      },
      countries: [],
      confimCancel: {dialog: false},
      loadingSave: false,
    }),
    watch: {
      'data.dialog': function(value) {
        if(value) {
          this.aux = JSON.parse(JSON.stringify(this.dataNumber))
          if(!this.dataNumber.number && this.url) {
            let number = this.url.replace(/\D/g, "")
            this.countries
            .filter(c => number.startsWith(c.dialCode))
            .forEach(c => this.dataNumber.dialCode = c.dialCode)
            this.dataNumber.number = number.substring(this.dataNumber.dialCode.length)
          }
        }
      },
    },
    computed: {
      formattedMessage() {
        let text = this.dataNumber.message

        // Regras simples estilo WhatsApp
        text = text.replace(/\*(.*?)\*/g, "<b>$1</b>")   // *bold*
        text = text.replace(/_(.*?)_/g, "<i>$1</i>")     // _italic_
        text = text.replace(/~(.*?)~/g, "<s>$1</s>")     // ~strike~
        text = text.replace(/`(.*?)`/g, "<code>$1</code>") // `code`

        return text
      }
    },
    mounted: function() {
      const countriesObj = countryCodes.customList(
        'countryCode',
        '{countryNameEn},{countryCode},{countryCallingCode}'
      )

      this.countries = Object.values(countriesObj).map(item => {
        const [name, code, dialCode] = item.split(',')
        return {
          name,
          code: code.toLowerCase(),
          dialCode,
          flagCode: code.toLowerCase()
        }
      })
    },
    methods: {
      save: function() {
        if(this.autoShortLinks) {
          this.loadingSave = true
          let urls = this.extractLinks(this.dataNumber.message)
          if(urls.length > 0)
            urls.forEach(url => {
              apiV1OnlineAddresses
              .post({url: url})
              .then(response => {
                  let currentUrl = `${window.location.host.replace('www.', '')}`;
                  this.dataNumber.message = this.dataNumber.message.replace(url, `${currentUrl}/${response.data.code}`)
                  if(this.extractLinks(this.dataNumber.message).length <= 0) {
                    this.loadingSave = false
                    this.onSave(this.getWhatsappUrl())
                  }
                }
              ).catch(() => {
                this.loadingSave = false
              })
            })
          else {
            this.onSave(this.getWhatsappUrl())
            this.loadingSave = false
          }
        }else {
          this.onSave(this.getWhatsappUrl())
        }
      },
      extractLinks: function (text) {
        if (!text) return []

        // Regex para URLs ignorando localhost e migly.in
        const urlRegex = /\b((?!(?:https?:\/\/)?(?:localhost|migly\.in))((?:https?:\/\/|ftp:\/\/|www\.)[^\s<>\]]+))/gi


        const urls = text.match(urlRegex) || []

        return [...urls]
      },
      applyFormat(type, emoji) {
        const textarea = this.$refs.messageInput.$el.querySelector('textarea')
        const start = textarea.selectionStart
        const end = textarea.selectionEnd
        const text = this.dataNumber.message
        const selected = text.substring(start, end)

        let wrapper = ""
        switch (type) {
          case 'bold': wrapper = "*"; break
          case 'italic': wrapper = "_"; break
          case 'strike': wrapper = "~"; break
          case 'code': wrapper = "`"; break
          case 'emoji': wrapper = ""; break
        }

        const newText =
          text.substring(0, start) +
          wrapper + selected  + (emoji ? emoji : '') + wrapper +
          text.substring(end)

        this.dataNumber.message = newText

        // Restaura a seleção após inserir
        this.$nextTick(() => {
          textarea.setSelectionRange(start + wrapper.length, end + wrapper.length)
          textarea.focus()
        })
      },
      addEmoji(emoji) {
        this.applyFormat('emoji', emoji.native)
      },
      getWhatsappUrl() {
        if (!this.dataNumber.dialCode || !this.dataNumber.number) return null

        // monta número (remove espaços/traços)
        const phone = (this.dataNumber.dialCode + this.dataNumber.number).replace(/\D/g, "")

        // codifica mensagem
        const message = encodeURIComponent(this.dataNumber.message || "")

        return `https://api.whatsapp.com/send/?phone=${phone}&text=${message}`
      },
    },
  }
</script>
<style scoped>
::v-deep .emoji-mart {
  max-width: none !important;
  width: 100% !important;
}

/* Força qualquer picker */
.emoji-mart,
.emoji-mart * {
  max-width: none !important;
  width: 100% !important;
}
.whats-panel {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  max-height: 100vh;
  background: #FFFFFF;
  font-family: 'Montserrat', sans-serif;
}
.whats-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
}
.whats-header-spacer {
  width: 34px;
}
.whats-header-title {
  display: flex;
  align-items: center;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 1.05rem;
  color: #101827;
}
.whats-header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #25D366;
  margin-right: 0.5rem;
}
.whats-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: #E3F1FA;
  color: #5B6472;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.whats-close-btn:hover:not(:disabled) {
  background: #DDEBFA;
  transform: translateY(-1px);
}
.whats-close-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.whats-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0.25rem 1.25rem 1rem;
}
.whats-section-label {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 0.9rem;
  color: #101827;
  margin: 0.6rem 0 0.6rem;
}
.whats-section-desc {
  color: #5B6472;
  font-size: 0.8rem;
  margin: 0 0 0.75rem;
}
.whats-text-field ::v-deep .v-input__slot {
  background: #F7F5EF !important;
  box-shadow: none !important;
}
.whats-format-toolbar {
  display: flex;
  gap: 0.4rem;
  margin-bottom: 0.75rem;
}
.whats-format-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 0.7rem;
  border: 1px solid rgba(16,24,39,0.08);
  background: #F7F5EF;
  color: #5B6472;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}
.whats-format-btn:hover {
  background: #E3F1FA;
  color: #0277BD;
  transform: translateY(-1px);
}
.whats-emoji-row {
  display: flex;
  margin: 0.4rem 0 0.75rem;
}
.whats-emoji-btn {
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(2, 119, 189, 0.3);
  background: #FFFFFF;
  border-radius: 999px;
  padding: 0.5rem 1rem;
  color: #0277BD;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.82rem;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.whats-emoji-btn:hover {
  background: #E3F1FA;
  transform: translateY(-1px);
}
.whats-preview-card {
  background: #F7F5EF;
  border-radius: 1rem;
  padding: 0.85rem 1rem;
  margin: 0.5rem 0 0.5rem;
}
.whats-preview-label {
  color: #5B6472;
  font-size: 0.78rem;
  font-weight: 700;
  margin: 0 0 0.3rem;
}
.whats-switch {
  margin-top: 0.75rem;
}
.whats-switch ::v-deep label {
  color: #101827;
  font-size: 0.88rem;
}
.whats-info-card {
  display: flex;
  align-items: flex-start;
  background: #E3F1FA;
  border-radius: 1rem;
  padding: 0.75rem 1rem;
  color: #0277BD;
  font-size: 0.82rem;
  font-weight: 600;
  margin-top: -0.4rem;
}
.whats-footer {
  flex: 0 0 auto;
  display: flex;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background: #FFFFFF;
  border-top: 1px solid #F0EEE7;
}
.whats-test-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  border: 1px solid rgba(37,211,102,0.4);
  background: rgba(37,211,102,0.08);
  color: #128C4A;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.75rem 1.3rem;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.whats-test-btn:hover {
  background: rgba(37,211,102,0.16);
  transform: translateY(-1px);
}
.whats-save-btn {
  flex: 1;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #00BDB3 0%, #0277BD 100%);
  color: #FFFFFF;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.75rem 1rem;
  box-shadow: 0 8px 18px rgba(2, 119, 189, 0.28);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.whats-save-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(2, 119, 189, 0.38);
}
.whats-save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}
.whats-save-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #FFFFFF;
  animation: whats-spin 0.7s linear infinite;
}
@keyframes whats-spin {
  100% { transform: rotate(360deg); }
}
@media (prefers-reduced-motion: reduce) {
  .whats-save-spinner {
    animation: none;
  }
}
</style>
